<template>
  <div class="offres_grid">
   <span class="mob_counter">{{ ListOffres.length }} <template v-if="ListOffres.length > 1">offres</template><template v-else>offre</template> </span>
   <div class="offres" v-if="ListOffres.length > 0">
    <a class="offre" :href="offre.permalink" v-for="offre in ListOffres" :key="offre.ID" :title="offre.post_title">
        <span class="etat" v-if="offre.type == 'fete-manifestation' && offre.taxonomy.etatevenement">
          {{ translateTaxo(offre.taxonomy.etatevenement, 'etatevenement') }}
        </span>
        <div class="thumbnail">
          <img loading="lazy" :src="offre.thumbnail" :alt="offre.post_title" :title="offre.post_title" v-if="offre.thumbnail" />
          <span v-else class="no-thumbnail"></span>
          <span class="counterPictures" v-if="offre.thumbnail && offre.acf.galerie.length > 0">{{ offre.acf.galerie.length }}</span>
          <TarifsView 
            v-if="offre.acf.TARIFSs" 
            :tarifs="offre.acf.TARIFSs">
          </TarifsView>
        </div>
        <button class="btn_wishlist" role="button" @click="addWishlist(index, offre.syndication_id, $event)" v-if="this.$parent.wishlist.includes(offre.syndication_id) == false">{{ $t("message.ajouter_carnet") }}</button>
        <button class="btn_wishlist liked" role="button" @click="removeWishlist(index, offre.syndication_id, $event)" v-else>{{ $t("message.retirer_carnet") }}</button>
        <ul class="infos">
          <li class="commune" v-if="offre.taxonomy.commune">{{ translateTaxo(offre.taxonomy.commune, 'commune') }}</li>
          <li v-if="this.seLoger.includes(offre.type)" class="classement" :data-classement="translateTaxo(offre.taxonomy.classement, 'classement')">{{ translateTaxo(offre.taxonomy.classement, 'classement') }}</li>
          <li v-if="this.seBalader.includes(offre.type) && offre.acf.DISTANCE !== ''" class="distance">{{ offre.acf.DISTANCE }} <span v-if="offre.acf.DISTANCE < 2">km</span><span v-else>kms</span></li>
        </ul>

        <DatesView 
          v-if="offre.type == 'fete-manifestation'" :offre="offre">
        </DatesView>

        <h2 v-html="offre.post_title"></h2>
        
      </a>
   </div>
   <span class="no-offers" v-else>{{ $t("message.aucune_offre") }}...</span>
   <PaginationView v-on:moreOffres="moreOffres(pagination)" :offres="offres" :pagination="pagination" :api="api"></PaginationView>
  </div>
</template>
<script>
/* eslint-disable */
import axios from 'axios';
import PaginationView from './PaginationView.vue';
import DatesView from './Agenda/DatesView.vue';
import TarifsView from './TarifsView.vue';
export default {  
  name: 'ListeOffres',
  components: {
    PaginationView,
    DatesView,
    TarifsView
  },
  data: function() {
    return {
      renderList: this.offres,
      currentWishlist: [],
      seLoger : ['hotel', 'camping', 'hebergementcollectif', 'meuble-chambre-hote'],
      seBalader : ['itineraire-tourisme'] 
    }
  },
  props: ['offres', 'pagination', 'api', 'geoloc', 'showmap', 'showfiltres'],  
  methods : {
    addOffre(api, pagination, offres) {
      const taboffres = [];
      for(let i=0; i<(pagination.current*api.per_page); i++) { 
        if(offres[i] !== undefined) {
          taboffres.push(offres[i]);
        }
      }
      return taboffres;
    },
    moreOffres(pagination) {
      if(pagination.current < pagination.page) {
        pagination.current++;
      }
    },
    translateTaxo(obj, type) {
      const filters = this.$parent.filtres;
      if(obj) {
        for (let i = 0; i < obj.length; i++) {
          const termId = obj[i];
          
          const matchingTerm = filters[type].terms.find(term => term.term_id === termId);

          if (matchingTerm) {
            return matchingTerm.name;
          }
        }
      }
      
      return null;
    },
    addWishlist(index, id, event) {
      event.preventDefault();
      var params = new URLSearchParams();
      params.append('action', 'addWishlist');
      params.append('nonce', comtourismeplugin.nonce); 
      params.append('wishlist_cookie', this.$parent.wishlist_id);
      params.append('syndication_id', id);

      axios
      .post(this.api.ajax, params)
      .then(response => this.addElementSuccess(response.data, id)) 
      .catch(error => {
        console.log(error);
      })
    },
    removeWishlist(index, id, event) {
      event.preventDefault();
      var params = new URLSearchParams();
      params.append('action', 'removeWishlist');
      params.append('nonce', comtourismeplugin.nonce); 
      params.append('wishlist_cookie', this.$parent.wishlist_id);
      params.append('syndication_id', id);

      axios
      .post(this.api.ajax, params)
      .then(response => this.removeElementSuccess(response.data, id)) 
      .catch(error => {
        console.log(error);
      })
    },
    addElementSuccess(response, id) {
      if(response.success == true && response.data.action == 'addWishlistCreated') {
        let date = new Date(Date.now() + (86400000*30)*3);
        date = date.toUTCString();
        document.cookie = "wishlist="+response.data.wishlist_cookie+"; expires="+date+"; path=/"; 
        this.$parent.wishlist_id = response.data.wishlist_cookie;
        let wishlistUpdate = this.$parent.wishlist;
        wishlistUpdate.push(id);
        this.currentWishlist = wishlistUpdate;
        return false;
      }
      if(response.success == true && response.data.action == 'addWishlist') {
        let wishlistUpdate = this.$parent.wishlist;
        wishlistUpdate.push(id);
        this.currentWishlist = wishlistUpdate;
        return false;
      }
    },
    removeElementSuccess(response, id) {
      if(response.success == true && response.data.action == 'removeWishlist') {
        let wishlistUpdate = this.$parent.wishlist;
        let position = wishlistUpdate.indexOf(id);
        wishlistUpdate.splice(position, 1);
        this.currentWishlist = wishlistUpdate;
        return false;
      }
    }
  },
  mounted() {
    this.currentWishlist = this.$parent.wishlist;
  },
  computed : { 
    ListOffres() {
      let offres = this.addOffre(this.api, this.pagination, this.offres);
      return offres;
    }
  }
} 
</script>